export default __webpack_public_path__ + "static/media/info_icon.a7c34331.svg";